/**
 * Created by guga on 7/21/2016.
 */

 import { CompanyService }  from '../../services/company.service';
 import { AppDataService } from '../../services';
 import { TranslationService } from '../../services';
import { JobBean } from './job.bean';
import { ItemCheckJobBean } from './ItemCheckJob';
import {GotoRoomJobBean} from './GotoRoomJob'
import {SelectItemJobBean} from './SelectItemJob'
import { PositionJobBean } from './PositionJob';
declare var Swal: any
declare var $: any
 export class WritBean {

  public jobs:JobBean[];
  public completed:boolean;
  public name:string;
  public group;
    public _companyService : CompanyService;
    public _appData : AppDataService;
    public translate: TranslationService
    public processCompleted=false;
    public testSuccess=false;
    constructor (){
       this.name =""
       this.completed=false; 
       this.jobs=[];
       this.group=""
    }
    public setCompanyService(service){
        this._companyService=service;
    }
    public setAppData(service){
        this._appData=service;
    }
    public setTranslation(service){
        this.translate=service;
    }
    public toDB() {
      let jobs=[]
      this.jobs.forEach(job=>{
        let dbjob=job.toDB();
        jobs.push(dbjob)
      })
      return {
      name : this.name,
      completed: this.completed,
      jobs: jobs,
      group:this.group
      }
    }
    public parse(val){
      this.name=val.name ? val.name : "";
      this.completed=val.completed ? val.completed : false
      this.group=val.group ? val.group : ""
      this.jobs=[];
      val.jobs.forEach(v=>{
        let job=new JobBean();
        job.parse(v)
        this.jobs.push(job)
      })
    }
    public calculateJobPoints(writ){
      let total=0
      let totalPoints=0;
      writ.jobs.forEach(j=>{
        if (!j.myPoints) {j.myPoints=0}
/*        switch(j.kind){
          case ("check"):{
            j.check.forEach(ck=>{
              if (ck.viewed){
                j.myPoints=j.myPoints+Number(ck.viewPt);
                total=total+Number(ck.viewPt)
              }
            })
            break
          }
          case ("order"):{
            break
          }
          case ("quis"):{
            if (writ.oneTime){
              if (j.dialog && j.dialog[0]){
                let dialog=j.dialog[0];
                if (dialog.success){
                  j.myPoints=j.pt;
                  total=total+Number(j.myPoints)
                }                
              }
            }
            else{
              if (j.completed){
                j.myPoints=j.pt;
                total=total+Number(j.pt)
              }

            }
            break
          }

          case ("equip"):{
            if (j.completed){
              j.myPoints=j.pt;
              total=total+Number(j.pt)
            }
            break

          }
          case ("container"):{
            if (j.completed){
              j.myPoints=j.pt;
              total=total+Number(j.pt)
            }
            break

          }
          case ("gotoRoom"):{
            if (j.completed){
              j.myPoints=j.pt;
              total=total+Number(j.pt)
            }
            break

          }

          case ("talkTo"):{
            if (j.completed){
              j.myPoints=j.pt;
              total=total+Number(j.pt)
            }
            break

          }
          case ("position"):{
            let positionsToCheck=j.positionItens.length
            j.positionItens.forEach(ck=>{
              if (ck.success){
                positionsToCheck--;
              }
            })
            if (positionsToCheck==0){
              j.completed=true;
            }
            else{
              j.completed=false;
            }
            break
          }

        }*/
        if (j.completed){
          j.myPoints=Number(j.actionPt);
          total=total+Number(j.actionPt);
        }
        totalPoints=totalPoints+j.actionPt;
      })
      this._appData.points=total;
      writ.myPoints=total
      writ.totalPoints=totalPoints
      if (!this._appData.instagramUser.profile_picture){
        this._appData.instagramUser.profile_picture=""
      }
      this._companyService.getCompanyWrit(this._appData.instagramUser,writ.group.toString()).set({
        full_name:this._appData.instagramUser.full_name,
        uid:this._appData.instagramUser.uid,
        group:writ.group,
        company:this._appData.company.dbId ? this._appData.company.dbId : 'none',
        profile_picture:this._appData.instagramUser.profile_picture,
        points:total,
        totalPoints:totalPoints
      }).then(val=>{})
      this.processCompleted=true;
      return writ;
    }
    public associateJob(writAssociation){
      this._companyService.getUserWrit(this._appData.instagramUser,writAssociation.writ.toString()).get().then(val=>{
        let wrt=val.data();
        if (wrt){//I only work the writ if it was given to the user
          let job=wrt.jobs[writAssociation.job];
          let date=new Date();
          job.viewDate=date.getTime();
          if (job){
            if (job.kind=="checkItem"){
              let jobBean=new ItemCheckJobBean();
              jobBean.parse(job);
              jobBean.associateJob(writAssociation);
              wrt.jobs[writAssociation.job]=jobBean.toDB();
              job=jobBean.toDB();
            }
            if (job.kind=="check"){
              let idx=writAssociation.jobIdx ? writAssociation.jobIdx : writAssociation.idx

              wrt.jobs[writAssociation.id].check[idx].viewed=true;
              if (wrt.jobs[writAssociation.id].callCell){
                this._appData.toggleCellPhone=true;
                //se job tiver website, abre o website no celular
                if (job.url){
                  let link=job.url
                  if (link.indexOf('{uid}')){
                    link = link.replace('{uid}',this._appData.instagramUser.uid);
                  }
                  this._appData.cellScreen='iframe'
                  this._appData.param=link
                }
                else{
                  let link='https://liveoffice.com.br/checklist?uid='+this._appData.instagramUser.uid+'&chk='+writAssociation.group+'&idx='+writAssociation.id
                  this._appData.cellScreen='iframe'
                  this._appData.param=link
                } 
              }
              if (wrt.jobs[writAssociation.id].check[idx].onSuccess){
                //possuo mensagem de sucesso e falha
                let check=wrt.jobs[writAssociation.id].check[idx]
                let text=null
                let allOk=true
                if (check.check==check.answer){
                  text=check.onSuccess
                }
                else{
                  text=check.onFail
                  allOk=false;
                }
                Swal.fire({
                  title:job.name,
                  text:text,
                  confirmButtonText: "Ok",
                  allowOutsideClick: false
                }).then((result) => {
                  if (result.value) {
                    if (check.onCompleteVideo){
                      //this._companyService.openExternalLink(writTest.onCompleteVideo,false)                        
                    }
                    if (check.onCompleteUrl){
                      let domain=window.location.origin
                      //window.location.replace(writTest.onCompleteUrl);
                    }
                    this.sendIframeMessage({
                      kind:'writResult',
                      params:{uid:this._appData.instagramUser.uid,success:allOk,points:check.viewPt}
                    });
                  }
                })
  
  
              }
            }
            if (job.kind=='talkTo'){
              let nid=job.nid;
              let date=new Date();
              let milis=date.getTime();
              wrt.jobs[writAssociation.id].talkTo={
                nid:nid,
                time:milis,
                sucess:true
              }
              //need to call npc

            } 
            if (job.kind=='container'){
              let date=new Date();
              let milis=date.getTime();
              let itens=[]
              writAssociation.itens.forEach(it=>{
                itens.push({
                  objectId:it.objectId,
                  recipeId:it.recipeId
                })
              })
              wrt.jobs[writAssociation.id].container={
                itens:itens,
                time:milis,
              }
              //need to call npc

            }
            if (job.kind=="order"){
              if (!wrt.jobs[writAssociation.id].clicks){
                wrt.jobs[writAssociation.id].clicks=[]
              }
              let date=new Date();
              let milis=date.getTime();
              let jobIdx=0;
              for (let i=0;i<wrt.jobs[writAssociation.id].orderItens.length;i++){
                if (wrt.jobs[writAssociation.id].orderItens[i].objectId==this._appData.object.objectId){
                  jobIdx=i;                  
                  wrt.jobs[writAssociation.id].orderItens[i].viewed=true;

                }
              }
              if (jobIdx>0){
                if (!wrt.jobs[writAssociation.id].orderItens[jobIdx-1].viewed){//vi o anterior
                  wrt.jobs[writAssociation.id].clicks.push({
                    time:milis,
                    success:false,
                    objectId:this._appData.object.objectId
                  });
                }
                else{
                  wrt.jobs[writAssociation.id].clicks.push({
                    time:milis,
                    success:true,
                    objectId:this._appData.object.objectId
                  });

                }
              }
              else{
                wrt.jobs[writAssociation.id].clicks.push({
                  time:milis,
                  success:true,
                  objectId:this._appData.object.objectId
                });
              }
            }
            if (job.kind=="quis"){
              if (!wrt.jobs[writAssociation.id].dialog){
                wrt.jobs[writAssociation.id].dialog=[]
              }
              wrt.jobs[writAssociation.id].dialog.push({
               answer:writAssociation.answer,
               question:writAssociation.question,
               success:writAssociation.success,
               answerTime:date.getTime()
              })
            }
            if (job.kind=="position"){
              if (!wrt.jobs[writAssociation.id].move){
                wrt.jobs[writAssociation.id].move=[]
              }
              let jobIdx=0
              let position=null
              for (let id=0;id<job.positionItens.length;id++){
                if (job.positionItens[id].objectId==this._appData.object.objectId){
                  jobIdx=id;
                  position=job.positionItens[id]
                }
              }
              let dx=Math.abs(position.x1-this._appData.object.position.x)
              let dy=Math.abs(position.y1-this._appData.object.position.y)
              let dz=Math.abs(position.z1-this._appData.object.position.z)

              if (dx<2 && dy<2 && dz<2){
                wrt.jobs[writAssociation.id].move.push({
                  objectId:this._appData.object.objectId,
                  success:true,
                  time:date.getTime()
                 })
                 this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this._appData.object.objectId).update({
                  position:{x:position.x1,
                            y:position.y1,
                            z:position.z1},
                  rotation:{x:position.rx1,
                            y:position.ry1,
                            z:position.rz1}
                 })
                 wrt.jobs[writAssociation.id].positionItens[jobIdx].success=true;
              }
              else{
                wrt.jobs[writAssociation.id].move.push({
                  objectId:this._appData.object.objectId,
                  success:false,
                  time:date.getTime()
                 })
                 wrt.jobs[writAssociation.id].positionItens[jobIdx].success=false;
              }

            }

            this.processCompleted=true
            this._companyService.getUserWrit(this._appData.instagramUser,writAssociation.writ.toString()).set(wrt).then(val=>{})
            if (job.triggers){
              this.sendIframeMessage(
                {
                  kind:'jobTriggers',
                  params:{job:job}
                })
            }
        }
        this.calculateJobPoints(wrt)
      }
      })
    }
    public testJob(writTest,wrt){
        if (wrt){//i have a writ to solve with this question
          if (writTest.id==null){
            writTest.id=writTest.job;
          }
          let job=wrt.jobs[writTest.id];
          if (job){
            if (job.kind=='checkItem'){
              let allOk=true;
              let checks=0;
              let objectId=writTest.entity.id
              job.param.itens[objectId]='completed';
              for (let prom in job.param.itens){
                if (job.param.itens[prom]=='completed'){
                  checks++;
                }
                else{
                  allOk=false
                }
              }
              if (allOk){
                wrt.jobs[writTest.id]=job;
                wrt.jobs[writTest.id].completed=true;
                let date=new Date();
                wrt.jobs[writTest.id].dateEnd=date.getTime();   
              }
              this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{              this.processCompleted=true                               })              

            }
            if (job.kind=='check'){
              //need to test all checks and see if all is ok or not
              let allOk=true;
              let checks=0;

              //define startDate and endDate
              if (job.dateEnd){//its a review as it was already tested
                if (!wrt.jobs[writTest.id].checkLog) {wrt.jobs[writTest.id].checkLog=[]}
                let date=new Date();
                let time=date.getTime()
                wrt.jobs[writTest.id].checkLog.push({date:time,check:job.check})
              }
              else{//really need to test it
                if (writTest.idx==null){//test is all checks are ok
                  job.check.forEach(ck=>{
                    if (!ck.check) {ck.check=false}
                    if (!ck.answer) {ck.answer=false}
                    if (ck.answer != ck.check){
                      allOk=false;
                    }
                    if (ck.check){
                      checks++;
                    }
                  }) 
                  if (job.maxCheck!=checks){
                    $('#npcModal').modal("hide");     
                    Swal.fire(job.onFail);
                    this._appData.toggleCellPhone=true;
                    this._appData.tiping=true;
                    this._appData.cellScreen='checklist'       
                    this._appData.param=job
                    this._appData.param=job
                    setTimeout((v)=>{
                      $('#checklist-screen-reload').click();
                    },1000)
              
                    //close npc if it is open
                    return;
                  }
                  if (allOk){
                    wrt.jobs[writTest.id].completed=true;
                  }
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();   
                }
                else{//test if only one check is ok
                  if (job.check[writTest.idx].answer != job.check[writTest.idx].check){
                    allOk=false;
                  }
                  let date=new Date();
                  wrt.jobs[writTest.id].check[writTest.idx].tested=date.getTime();   
                }
              }

              let text=""
              this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{})
              if (allOk){
                text=wrt.jobs[writTest.id].check[writTest.idx].onComplete
              }
              else{
                text=wrt.jobs[writTest.id].check[writTest.idx].onFail
              }
              this.processCompleted=true
              this.sendIframeMessage({
                kind:'writResult',
                params:{uid:this._appData.instagramUser.uid,success:allOk,points:3}
              });    
    
              if (text){
                this.testSuccess=true;    
              }

            }
            else if (job.kind=='order'){
              //need to test all checks and see if all is ok or not
              let allOk=true;
              let itensOnOrder=job.param.itens;             
              let testedItem=writTest.entity
              let completedCounter=0
              itensOnOrder.every((order,index)=>{
                if (!order.completed){
                  if (order.objectId==testedItem.id){
                    //success
                    completedCounter++;
                    order.completed=true;
                    return false;
                  }
                  else{
                    //fail
                    allOk=false;
                    return false;
                  }
                }
                else{
                  completedCounter++;
                  return true;
                  //go to next item.
                }
                
              })
              let text=""
              if (allOk){
                job.param.itens=itensOnOrder;
                wrt.jobs[writTest.id]=job;
                if (completedCounter==job.testActionPoint ){
                  text=writTest.onComplete
                  wrt.jobs[writTest.id].completed=true;
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();   
                }
                this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{              this.processCompleted=true                               })
              }
              else{
                text=writTest.onFail
              }
              if (text){
                //salva job como completo
                this.testSuccess=true;    
              }

            }
            else if (job.kind=='selectItem'){
              let logic=new SelectItemJobBean();
              logic.setAppData(this._appData);
              logic.setCompanyService(this._companyService);
              this.testSuccess=logic.testJob(writTest,job,wrt);
            }            
            else if (job.kind=='gotoRoom'){
              let logic=new GotoRoomJobBean();
              logic.setAppData(this._appData);
              logic.setCompanyService(this._companyService);
              this.testSuccess=logic.testJob(writTest,job,wrt);
            }
            else if (job.kind=='position'){
              let logic=new PositionJobBean();
              logic.setAppData(this._appData);
              logic.setCompanyService(this._companyService);
              this.testSuccess=logic.testJob(writTest,job,wrt);              
            }
            else if (job.kind=='talkTo'){
                wrt.jobs[writTest.id].completed=false;

                if (wrt.jobs[writTest.id].param.nids[writTest.npc]){
                  wrt.jobs[writTest.id].param.nids[writTest.npc]='complete'
                }
                let all=true;
                let points=0;
                for (let prop in wrt.jobs[writTest.id].param.nids){
                  if (wrt.jobs[writTest.id].param.nids[prop]!='complete'){
                    all=false
                  }
                  else{
                    points++;
                  }
                }
                if (all){
                  wrt.jobs[writTest.id].completed=true;
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();   
                  this.testSuccess=true
                }
                this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{              this.processCompleted=true})            
            }
            else if (job.kind=='quis'){
              if (wrt.oneTime){
                if (wrt.jobs[writTest.id].dateEnd){
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();    
                  Swal.fire({title:'Tarefa já foi feita',text:'Você já respondeu essa questão. Para fins da tarefa, conta a primeira vez que você a fez.'})
                }
                else{
                  wrt.jobs[writTest.id].completed=writTest.completed;
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();    
                }
              }
              else{
                wrt.jobs[writTest.id].completed=true;
                let date=new Date();
                wrt.jobs[writTest.id].dateEnd=date.getTime();   
              } 
              this.calculateJobPoints(wrt)
              this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{
                this.processCompleted=true
              })
              this.testSuccess=true;    
            }          
            else if (job.kind=='equip'){
              let all=true;
              job.param.itens.forEach(it=>{
                let hasIt=false;
                if (writTest.equip){
                  writTest.equip.forEach(eq=>{
                    if (eq==it.objectId){
                      hasIt=true;
                    }
                  })
                }
                if (!hasIt){
                  all=false;
                }
              })

              if (all){
                wrt.jobs[writTest.job].completed=true;
                let date=new Date();
                wrt.jobs[writTest.job].dateEnd=date.getTime();   
                this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{})
                this.testSuccess=true;      
                job.success=true          
              }             
              else{
                job.success=false;
                this.testSuccess=false;                
              }
            }
            else if (job.kind=='container'){
              let all=true;
              let itens=[]
              if (writTest.itens){
                itens=writTest.itens
              }
              else if (job.container && job.container.itens){
                itens=job.container.itens
              }
              job.recipes.forEach(it=>{
                let check=false;
                itens.forEach(cit=>{
                  if (cit.recipeId==it.recipeId){
                    check=true;
                  }
                })
                if (!check){
                  all=false;
                }              
              }) 
              if (all){
                wrt.jobs[writTest.job].completed=true;
                let date=new Date();
                wrt.jobs[writTest.job].dateEnd=date.getTime();   
                this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{})
                this.testSuccess=true;                
              }             
              else{
                this.testSuccess=false;                
              }
            }            

          }
          if (job.triggers){
            this.sendIframeMessage(
              {
                kind:'jobTriggers',
                params:{job:job}
              })
          }
  
        }
        
        else{
          if (writTest.kind=='check'){
            Swal.fire("Você não escolheu os itens de equipamento necessários para ir para a corrida. Fale comigo novamente e aceite a tarefa de escolher os itens de equipamento para poder fazer a corrida.")
            $('#npcModal').modal("hide");     

          }
        }

        this.calculateJobPoints(wrt)

    }
    public runTrigger(job,trigger){
      if (trigger.kind=='text'){
        if (this._appData.room.background2d && this._appData.room.background2d.length>0){
          Swal.fire({
            title:job.name,
            text:trigger.text,
            confirmButtonText: "OK",
            allowOutsideClick: false
          }).then((result) => {
  /*          if (result.value) {
              if (writTest.onCompleteVideo){
                this._companyService.openExternalLink(writTest.onCompleteVideo,false)                        
              }
              if (writTest.onCompleteUrl){
                let domain=window.location.origin
                window.location.replace(writTest.onCompleteUrl);
              }
            }*/
          })
        }
        else{
          let panel={
            text:trigger.text,
            image:trigger.image,
            video:trigger.video,
            space:0
          }
          this.sendIframeMessage({
            kind:'openPanel',
            space:0,
            param:panel}
          );    
  
        }

      }
      else if (trigger.kind=='teleport'){
        this.sendIframeMessage({
          kind:'updateUserStatus',
          params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:trigger.x,y:trigger.y,z:trigger.z?trigger.z:0}}
        });    
      }
    }
    public resetJob(job){
      if (job.kind=='position'){
        //need to put each object of position in the start position
        job.positionItens.forEach(v=>{
          this._companyService.getUserRoomItemRef(this._appData.room.id).doc(v.objectId).update({
            position:{
              x:v.x0,
              y:v.y0,
              z:v.z0
            },
            rotation:{
              x:v.rx0,
              y:v.ry0,
              z:v.rz0
            }
          })
        })

      }
    }
    public giveJob(writData){
      if (!this._appData.activeWrits){
        this._appData.activeWrits={}
      }
      if (this._appData.activeWrits[writData.writ]){
        let wr=this._appData.activeWrits[writData.writ]
        let date=new Date();
        writData.dateStart=date.getTime();
        wr.dateStart=writData.dateStart
        this._companyService.getUserWrit(this._appData.instagramUser,writData.writ.toString()).set(wr).then(val3=>{ 
            this.processCompleted=true;       
        });
          this.sendIframeMessage(
            {
              kind:'jobTriggers',
              params:{job:wr.jobs[writData.job],kind:'giver'}
            })         
      }
      else{        
        let variable=this._appData.company ? this._appData.company.dbId : null;
        if (variable.localServer){
            let wr=variable.writs[writData.writ]
            this._appData.activeWrits[wr.group]=wr; 
            this.giveJob(writData);  
        }
        this._companyService.getWrits(variable).doc(writData.writ).get().then(v=>{
          let wr=v.data()
          if (wr){
            this._appData.activeWrits[wr.group]=wr; 
            this.giveJob(writData);  
          }
          else{
            variable=null;
            this._companyService.getWrits(variable).doc(writData.writ).get().then(v=>{
              let wr=v.data()
              if (wr){
                this._appData.activeWrits[wr.group]=wr; 
                this.giveJob(writData);      
              }
            })
          }
        });
  
      }
    }
    public sendIframeMessage(messageKind){
   		const event = new CustomEvent('angularMessage',{detail:messageKind});
  		window.dispatchEvent(event);

    }

};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/quests/writ.bean.ts